import React from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { usePageTitle } from '../hooks/usePageTitle';
import { BarChart2, FolderOpen, Users, FileText, MessageSquare, HelpCircle, LogOut } from 'lucide-react';
import { useAuth } from '../context/AuthContext';
import './Dashboard.css';

const ROLE_LABELS = {
  admin: 'Administrator',
  internal_user: 'Internal User',
  external_user: 'External User',
};

const INTERNAL_LINKS = [
  { icon: <BarChart2 size={18} />, label: 'Internal Reports', desc: 'Analytics and performance dashboards', href: '#' },
  { icon: <FolderOpen size={18} />, label: 'Project Files', desc: 'Access shared project resources', href: '#' },
  { icon: <Users size={18} />, label: 'Team Directory', desc: 'Browse the team and contacts', href: '#' },
];

const EXTERNAL_LINKS = [
  { icon: <FolderOpen size={18} />, label: 'Your Projects', desc: 'View ongoing and completed deliverables', href: '#' },
  { icon: <FileText size={18} />, label: 'Documents', desc: 'Proposals, SOWs, and reports', href: '#' },
  { icon: <MessageSquare size={18} />, label: 'Support', desc: 'Raise a ticket or contact your PM', href: '/contact' },
  { icon: <HelpCircle size={18} />, label: 'FAQs', desc: 'Common questions about our process', href: '#' },
];

export default function Dashboard() {
  usePageTitle('Dashboard');
  const { user, role, signOut } = useAuth();
  const navigate = useNavigate();

  const handleSignOut = async () => {
    await signOut();
    navigate('/login');
  };

  const links = role === 'internal_user' ? INTERNAL_LINKS : EXTERNAL_LINKS;
  const greeting = role === 'internal_user' ? 'Internal Portal' : 'Client Portal';

  return (
    <div className="dashboard-page">
      <div className="dashboard-card">
        <div className="dashboard-header">
          <div>
            <h2>{greeting}</h2>
            <p>{user?.email}</p>
          </div>
          <span className={`role-badge role-${role}`}>{ROLE_LABELS[role] || role}</span>
        </div>

        <div className="dashboard-body">
          <p>Welcome back, <strong>{user?.email?.split('@')[0]}</strong>. Here's what you have access to:</p>
          <ul className="dashboard-links">
            {links.map((item, i) => (
              <li key={i}>
                {item.href && item.href !== '#' ? (
                  <Link to={item.href} className="dashboard-link-row">
                    <span className="dash-link-icon">{item.icon}</span>
                    <span className="dash-link-text">
                      <span className="dash-link-label">{item.label}</span>
                      <span className="dash-link-desc">{item.desc}</span>
                    </span>
                  </Link>
                ) : (
                  <div className="dashboard-link-row dashboard-link-soon">
                    <span className="dash-link-icon">{item.icon}</span>
                    <span className="dash-link-text">
                      <span className="dash-link-label">{item.label}</span>
                      <span className="dash-link-desc">{item.desc}</span>
                    </span>
                    <span className="dash-link-badge">Soon</span>
                  </div>
                )}
              </li>
            ))}
          </ul>
        </div>

        <button className="dashboard-signout" onClick={handleSignOut}>
          <LogOut size={15} style={{ marginRight: '0.4rem' }} />
          Sign Out
        </button>
      </div>
    </div>
  );
}
